export default __webpack_public_path__ + "static/media/ic_add_brik.1a1ee1ff.svg";